import { Grid } from '@mui/material';
import React, {  } from 'react';
import './PortManagement.scss';
import PortManagementInput from './PortManagementInput';
import PortManagementTable from './PortManagementTable';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';

const PortManagement: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    return (
        <Grid container>
            <Grid container className="input-fields">
                <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                    <PortManagementInput></PortManagementInput>
                </div>
            </Grid>
            <Grid container className="datatable">
                <PortManagementTable>
                </PortManagementTable>
            </Grid>
        </Grid>
    )
};

export default PortManagement;